import { QueryClient } from '@tanstack/react-query';
import { shouldRetry } from '@web/lib';

/**
 * Query-Client je Plattform. Fehler zeigen die Seiten selbst (Retry-Zustand), kein globaler Toast.
 * Retry nur bei Netz- und 5xx-Fehlern (einmal), nie bei 4xx (`shouldRetry` aus @web/lib).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: shouldRetry, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}
